import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IUserState }           from 'Redux/Slices/User/UserSlice';
import User                     from 'Domain/Models/User/User';
import { removeActionTypes }    from 'Utils/ReducerUtility';
import { Organizer }            from '../../../../Domain/Models';

export const authenticationRequest = (state: Draft<IUserState>, { type }: PayloadAction<{ username: string, password: string }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const authenticationSuccess = (state: Draft<IUserState>, { type, payload }: PayloadAction<{
  user?: User,
  authentication: {
    accessToken: null| string,
    refreshToken: null| string,
    accessTokenExpiresAt: null| Date,
    refreshTokenExpiresAt: null| Date
  } | null,
  organisations: null | Organizer[],
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.currentUser = payload.user || state.currentUser;
  state.organisations = payload?.organisations || state.organisations;
};

export const authenticationFailure = (state: Draft<IUserState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
